
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ProcessSection from './components/ProcessSection';
import ProjectsGallerySection from './components/ProjectsGallerySection';
import CTASection from './components/CTASection';

export default function ProjectsPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <ProcessSection />
        <ProjectsGallerySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
